import React from "react";
import { Container } from "manifest-components/src/Containers";
import { HeaderHeight, MobileHeaderHeight } from "./index";

const HeaderPlaceholder = () => (
  <Container
    style={{
      backgroundColor: "transparent",
      height: HeaderHeight,
      width: "100%",
    }}
    className="header-placeholder"
    $mobileHeight={MobileHeaderHeight}
  />
);

export default HeaderPlaceholder;
